export const form = {
  headerTitle: 'CONVIÉRTETE EN DISTRIBUIDOR DE RIFFEL',
  headerTitleResult: 'Gracias por las informaciones',
  formTitle: 'Complete la información a continuación para que podamos ayudarle',
  resultTitle:
    'A continuación encontrará información sobre nuestros distribuidores.',
  name: 'Razón social',
  name_placeholder: 'Introduzca el nombre de la empresa',
  cnpj: 'CNPJ',
  cnpj_placeholder: 'Introduce tu CNPJ',
  invalid_feedback_cnpj: 'CNPJ no válido',
  responsible: 'Responsable',
  responsible_placeholder: 'Introduzca el nombre del responsable de la empresa',
  segments: '¿Qué segmento? (seleccione más de uno si es necesario)',
  products:
    '¿Cuál es el producto de interés? (seleccione más de uno si es necesario)',
  kits: '¿Cuántos kits de transmisión/tracción venden al mes?',
  services:
    '¿Cómo prefieres que te atiendan? (seleccione más de uno si es necesario)',
  email: 'E-mail',
  email_placeholder: 'Escribe tu correo electrónico',
  phone: 'WhatsApp',
  phone_placeholder: 'Introduce tu número de WhatsApp',
  state: 'Estado',
  city: 'Ciudad',
  city_placeholder: 'Entra a la ciudad',
  zipcode: 'Código postal',
  zipcode_placeholder: 'Ingrese el código postal',
  uf: 'UF',
  invalid_feedback: '*Campo obligatorio',
  button: ' Enviar información',
};

export const result = {};
